var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google 1",
    clipPath: "url(#clip0_233_9020)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8206 7.70055L10.4786 7.7002C10.1544 7.7002 9.8916 7.96295 9.8916 8.28716V10.6326C9.8916 10.9568 10.1544 11.2196 10.4786 11.2196H14.6132C14.1604 12.3945 13.3154 13.3785 12.2373 14.0037L14.0003 17.0556C16.8283 15.4201 18.5003 12.5503 18.5003 9.33777C18.5003 8.88036 18.4666 8.55337 18.3991 8.18518C18.3479 7.90544 18.105 7.70055 17.8206 7.70055Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.49996 14.7434C7.47657 14.7434 5.71018 13.6379 4.76149 12.002L1.70972 13.761C3.26274 16.4526 6.17206 18.2651 9.49996 18.2651C11.1325 18.2651 12.6729 17.8256 14 17.0596V17.0554L12.237 14.0035C11.4306 14.4712 10.4974 14.7434 9.49996 14.7434Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14 17.0595V17.0553L12.237 14.0034C11.4306 14.4711 10.4975 14.7434 9.5 14.7434V18.2651C11.1326 18.2651 12.6731 17.8255 14 17.0595Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.02174 9.26535C4.02174 8.268 4.29392 7.33492 4.76154 6.52854L1.70976 4.76953C0.939523 6.09236 0.5 7.62861 0.5 9.26535C0.5 10.9021 0.939523 12.4383 1.70976 13.7612L4.76154 12.0022C4.29392 11.1958 4.02174 10.2627 4.02174 9.26535Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.49996 3.78688C10.8194 3.78688 12.0314 4.25572 12.978 5.03559C13.2116 5.22797 13.551 5.21408 13.7649 5.00016L15.4268 3.33832C15.6695 3.0956 15.6522 2.6983 15.3929 2.47337C13.8068 1.09739 11.7432 0.265137 9.49996 0.265137C6.17206 0.265137 3.26274 2.07769 1.70972 4.76932L4.76149 6.52833C5.71018 4.8924 7.47657 3.78688 9.49996 3.78688Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.9781 5.03559C13.2116 5.22797 13.5511 5.21408 13.765 5.00016L15.4268 3.33832C15.6695 3.0956 15.6522 2.6983 15.393 2.47337C13.8069 1.09736 11.7432 0.265137 9.5 0.265137V3.78688C10.8194 3.78688 12.0314 4.25572 12.9781 5.03559Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_9020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.265137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.0add43df2f0744652c1db041fa34de14.svg";
export { ForwardRef as ReactComponent };